<template>
  <v-container :class="'mt-0 pt-0 '" fluid>
    <v-card class="pa-0 ma-0 mt-5 mb-5" elevation="0">
      <v-row>
        <v-col cols="3" class="mb-0 mt-0 pb-0 pt-0">
          <SelectFilter
            class="mb-0 pb-0"
            :label="this.$t('cards.banks')"
            filtered
            item-text="bankName"
            item-value="bankId"
            :items-root="banks"
            :disabled="2"
            :selectedItem="bankFilter"
            :prepend-icon="'mdi-bank'"
            notMultiple
            v-on:changed="(items) => (this.bankFilter = items)"
          />
        </v-col>
        <v-col cols="3" class="mb-0 mt-0 pb-0 pt-0">
          <v-text-field
            class="mb-0 pb-0"
            :label="this.$t('cards.branches')"
            :value="branchFilter"
            @change="(v) => (branchFilter = v)"
            :append-icon="'mdi-close'"
            @click:append="() => (branchFilter = '')"
            :prepend-icon="'mdi-source-branch'"
          />
        </v-col>
        <v-col class="my-0 py-0" cols="3">
          <combobox-filter2000
            class="mb-0 pb-0"
            v-model="statusTypesFilterArray"
            :label="this.$t('referenceBooks.products.Status')"
            :items="statusTypes"
            itemText="statusName"
            itemValue="statusId"
            translate
            :localizationFunc="
              (val) => $t('productStatusNames.statusName' + val.statusId)
            "
            :prepend-icon="'mdi-clock-outline'"
            style="z-index: 200"
          />
        </v-col>
        <v-col cols="1" class="mb-0 mt-0 pb-0 pt-0"></v-col>
        <v-col cols="2" class="mb-0 mt-0 pb-0 pt-0">
          <v-row>
            <v-spacer />
            <SearchButtons
              v-on:clear="clearFilters"
              v-on:get="getData"
            />
          </v-row>
        </v-col>
        <v-spacer />
      </v-row>
    </v-card>
    <v-card>
      <v-card-title class="mt-3 my-0 pb-1 pt-2">
        <BranchDialog
          v-if="this.$store.getters.CAN_ADD_BRANCHES"
          :mode="0"
          :bank="bankParam"
          v-on:created="onCreated"
          v-on:error="onError"
        />
        <BranchDialog
          v-if="this.$store.getters.CAN_EDIT_BRANCHES && isActive"
          :mode="1"
          :branch="selectedBranch[0]"
          v-on:saved="onSaved"
          v-on:error="onError"
        />
        <Confirm
          v-if="this.$store.getters.CAN_DELETE_BRANCHES && isActive"
          :title="this.deleteBranchTitle"
          :text="confirmText"
          v-on:ok="onDelete"
          :icon-name="'mdi-delete'"
          :tooltipText="$t('confirm.deleteBranch')"
        />
        <Confirm
          v-if="this.$store.getters.CAN_DELETE_BRANCHES && isNotActive"
          :disabled="this.$store.getters.CAN_DELETE_BRANCHES"
          :title="this.restoreBranchTitle"
          :tooltipText="$t('confirm.restoreBranch')"
          v-on:ok="onRestore"
          iconName="mdi-restore"
        />

        <v-spacer />
        <ChooseBranchesToPinDialog
          v-if="this.$store.getters.CAN_PIN_UNPIN_BRANCHES && canPin"
          :branch="selectedBranch[0]"
          :key="chooseBranchesToPinDialog"
          @close="
            () => {
              this.chooseBranchesToPinDialog++;
            }
          "
          @pinned="onPinned"
        />
        <Confirm
          v-if="this.$store.getters.CAN_PIN_UNPIN_BRANCHES && canUnpin"
          :title="this.$t('referenceBooks.branches.UnpinBranch')"
          :text="this.$t('referenceBooks.branches.UnpinBranch') + '?'"
          v-on:ok="onUnpinBranch"
          :icon-name="'mdi-pin-off'"
          :tooltipText="this.$t('referenceBooks.branches.UnpinBranch')"
        />
        {{ $t("cards.total") }}: {{ totalCount }}
      </v-card-title >
      <LoadIcon v-if="loading" />
      <LightTable
        :headers="headers"
        :items="branches"
        :loading="loading"
        itemKey="branchId"
        defaultSortColumn="name"
        tooltipKey="parentBranchName"
        tooltipHeader="parentBranchName"
        tooltipValue="parentBranchName"
        :selectedItems="selectedBranch"
        :markedItems="changedBranchesId"
        :no-data-text="noDataText"
        singleSelect
        :sortBy="sortBy"
        :sortDesc="sortDesc"
        v-on:changedSortDesc="onChangeSortDesc"
        v-on:changedSort="onChangeSort"
        v-on:update="onUpdate"
        :height="tableHeight"
      />
    </v-card>
  </v-container>
</template>

<script>
import BranchDialog from '@/components/Dialogs/BranchDialog';
import ComboboxFilter2000 from '@/components/FiltersComponent/ComboboxFilter2000';
import SearchButtons from '../components/FiltersComponent/SearchButtons';
import SelectFilter from '../components/FiltersComponent/SelectFilter';
import LightTable from '@/components/Tables/LightTable';
import Confirm from '@/components/Confirm';
import LoadIcon from '@/components/LoadIcon';
import Vue from 'vue';
import ChooseBranchesToPinDialog from '@/components/ChooseBranchesToPinDialog';
import { notifyError, notifySuccess } from '@/services/notifications';
import tableHeightMixin from './mixins/tableHeightMixin';
import valIsNull from '@/services/valIsNull';

export default {
  name: 'Branches',
  mixins: [tableHeightMixin],
  components: {
    ChooseBranchesToPinDialog,
    BranchDialog,
    SelectFilter,
    Confirm,
    LightTable,
    SearchButtons,
    LoadIcon,
    ComboboxFilter2000,
  },
  data() {
    return {
      chooseBranchesToPinDialog: 0,
      loading: false,

      totalCount: '0',
      limit: 10,
      page: 1,

      // Для расчёта высоты таблицы
      offsetHeight: this.$store.getters.HEIGHT_OFFSET,
      headerH: 48,
      filterH: 56,
      tHeaderH: 44,
      tFooterH: 62,

      bankFilter: [],
      branchFilter: '',
      tempArray: {
        type: Array,
        default: [],
      },
      setStart: false,

      statusTypesFilterArray: [],
      statusTypes: [],

      sortBy: [],
      sortDesc: [],
      tempBranches: [],

      selectedBranch: [],
      changedBranchesId: [],
      banks: [],
      branches: [],
      apiUri: 'http://192.168.1.231/api',
      noData: false,
    };
  },
  watch: {
    filterJson() {
      this.getData();
    },
    selectedBranch() {
      this.chooseBranchesToPinDialog++;
    },
  },
  computed: {
    isActive() {
      return (
        this.selectedBranch.length === 1 &&
        this.selectedBranch[0].statusId === 1
      );
    },
    isNotActive() {
      return (
        this.selectedBranch.length === 1 &&
        this.selectedBranch[0].statusId === 2
      );
    },
    canUnpin() {
      return (
        this.isActive &&
        this.selectedBranch.every((b) => b.parentBranchId !== 0)
      );
    },
    canPin() {
      return (
        this.isActive &&
        !this.branches.some(
          (br) => br.parentBranchId === this.selectedBranch[0].branchId
        )
      );
    },
    propertiesResponse() {
      return { Devices: this.$t('errorsMessages.BranchHasDevices') };
    },
    bankParam() {
      return this.bankFilter == null || this.bankFilter.length == 0
        ? null
        : this.bankFilter;
    },
    deleteBranchTitle() {
      return (
        this.$t('confirm.deleteBranch') +
        ' ' +
        this.selectedBranch[0].name +
        '?'
      );
    },
    confirmText() {
      return this.$t('confirm.text');
    },
    restoreBranchTitle() {
      return (
        this.$t('confirm.restoreBranch') +
        ' ' +
        this.selectedBranch[0].name +
        '?'
      );
    },
    headers() {
      const result = [
        { text: '', value: '0', sortable: false },
        {
          text: this.$t('referenceBooks.banks.Name'),
          value: 'bankName',
          align: 'start',
          sortable: true,
        },
        { text: '', value: 'parentBranchName', width: '50px', sortable: true },
        {
          text: this.$t('referenceBooks.branches.Name'),
          value: 'name',
          align: 'start',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.branches.Address'),
          value: 'address',
          align: 'start',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.branches.Alias'),
          value: 'alias',
          align: 'start',
          sortable: true,
        },
      ];
      if (
        this.$store.getters.RIGHTS_ON_BANK_LEVEL ||
        this.$store.getters.RIGHTS_ON_BRANCH_LEVEL
      )
        result.splice(0, 1);

      return result;
    },
    noDataText() {
      return this.$t('cards.noData');
    },
    filterJson() {
      const result = {};

      result.branchName = !this.branchFilter ? '' : this.branchFilter;
      result.banksId =
        this.bankFilter == null || this.bankFilter.length == 0
          ? []
          : [this.bankFilter.bankId];
      result.statusesId =
        this.statusTypesFilterArray == null ||
        this.statusTypesFilterArray.length == 0
          ? []
          : this.statusTypesFilterArray.map((val) => val.statusId);

      return result;
    },
  },
  async mounted() {
    await this.$axios.products
      .getStatuses()
      .then((response) => response.data)
      .then((json) => {
        this.statusTypes = json;
      })
      .catch((error) => {
        console.error(error);
        this.statusTypes.push(
          { statusName: '123', productStatusId: 1 },
          { statusName: '321', productStatusId: 2 }
        );
      });
    this.setActiveStatusesForFilter();
    this.getData();
    this.getBanks();
  },
  methods: {
    setActiveStatusesForFilter() {
      this.statusTypesFilterArray = this.statusTypes.filter(
        (val) => val.statusId === 1
      );
    },
    async getBanks() {
      await this.$axios.banks
        .get()
        .then((response) => response.data)
        .then((json) => {
          this.banks = json;
          if (this.banks.length === 1) {
            this.bankFilter = this.banks[0];
          }
        })

        .catch((error) => {
          console.error(error);

          notifyError('', this.$t('Error'));
        });
    },
    onPinned(branchId) {
      this.markRow(branchId);
      this.getData();
    },
    onUpdate(items) {
      this.selectedBranch = items;
      this.changedBranchesId = [];
    },
    getSortedArray(branches) {
      const result = [];
      branches.forEach((b) => {
        if (b.parentBranchId === 0) {
          result.push(b);
          const childrens = branches
            .filter((br) => br.parentBranchId === b.branchId)
            .sort((b) => b.branchName);
          result.push(...childrens);
        }
      });

      return result;
    },
    compareParentID(a, b) {
      if (a == null && b != null) return -1;

      if (a != null && b == null) return 1;

      return a - b;
    },
    clearFilters() {
      if (this.banks.length > 1) {
        this.bankFilter = null;
      }
      this.setActiveStatusesForFilter();
      this.branchFilter = '';
      this.getData();
    },
    async getData() {
      if (this.loading) return;
      this.loading = true;
      this.selectedBranch = [];

      const params = {
        query: JSON.stringify(this.filterJson),
      };
      this.getCount(params);
      params.limit = await this.limit;
      params.offset = (await this.limit) * (this.page - 1);
      this.executeRequest(params);
    },
    async getCount(params) {
      this.$axios.branches
        .getCount(params)
        .then((response) => response.data)
        .then((json) => {
          this.paginationLength = Math.ceil(json.totalCount / this.limit);
          this.totalCount = json.totalCount;
        })
        .catch((error) => {
          this.onError(
            error,
            this.$t('referenceBooks.branches.GetFailedCount')
          );
        });
    },
    async onRestore() {
      const branch = this.selectedBranch[0];
      await this.$axios.branches
        .restore(branch.branchId)
        .then((response) => {
          if (response.status == 200) {
            notifySuccess(
              '',
              this.$t('Messages.BranchWasRestored', [branch.branchName])
            );
            this.selectedBranch = [];
          } else
            this.showMessage(
              this.$t('Restored'),
              `${this.$t('referenceBooks.branches.Name')}: ${
                branch.branchName
              }\n${this.$t('Status')}: ${response.status}`,
              'warn'
            );
          this.getData();
        })
        .catch((error) => {
          console.error(error);

          notifyError(this.$t('Error'), error);
          this.catchError(
            error,
            branch.branchName,
            this.$t('errorsMessages.Restore')
          );
        });
    },

    setBranches() {
      if (!this.setStart) {
        this.branches = [];
        this.setStart = true;
      }

      let i = 0;
      while (this.tempArray != null && this.tempArray.length != 0 && i++ < 10) {
        this.branches.push(this.tempArray.shift());
      }

      if (this.tempArray != null && this.tempArray.length != 0) {
        window.setTimeout(() => this.setBranches(), 300);
      } else {
        this.setStart = false;
        this.loading = false;
      }
    },
    async executeRequest(params) {
      await this.$axios.branches
        .get(params)
        .then((response) => response.data)
        .then((json) => {
          this.tempBranches = this.sortData(json, this.sortBy, this.sortDesc);
          this.branches = this.tempBranches.slice(0, 500);
          this.loading = false;
          this.noData = this.branches == null || this.branches.length == 0;
        })
        .catch((error) => {
          this.onError(error, this.$t('referenceBooks.branches.GetFailed'));
          this.loading = false;
        });
    },
    onChangeSort(sort) {
      this.sortBy = sort;

      if (this.sortDesc.length === this.sortBy.length)
        this.branches = this.sortData(
          this.tempBranches,
          this.sortBy,
          this.sortDesc
        ).slice(0, 500);
    },
    onChangeSortDesc(sortDesc) {
      this.sortDesc = sortDesc;

      if (this.sortDesc.length === this.sortBy.length)
        this.branches = this.sortData(
          this.tempBranches,
          this.sortBy,
          this.sortDesc
        ).slice(0, 500);
    },
    sortData(items, sortBy, desc) {
      items.sort(function(a, b) {
        let index = 0;

        while (index < sortBy.length) {
          const isDesc =
            desc !== null && desc[index] !== null && desc[index] === true
              ? true
              : false;

          if (valIsNull(a[sortBy[index]]) && valIsNull(b[sortBy[index]]))
            return 0;
          if (valIsNull(a[sortBy[index]])) return isDesc ? -1 : 1;
          if (valIsNull(b[sortBy[index]])) return isDesc ? 1 : -1;

          if (a[sortBy[index]] > b[sortBy[index]]) return isDesc ? -1 : 1;
          if (a[sortBy[index]] < b[sortBy[index]]) return isDesc ? 1 : -1;
          index++;
        }

        return 0;
      });

      return items;
    },
    setDefaultSort() {
      if (
        this.$store.getters.RIGHTS_ON_BANK_LEVEL ||
        this.$store.getters.RIGHTS_ON_BRANCH_LEVEL
      ) {
        //     this.sortBy = ['name'];
        //    this.sortDesc = [false];
      } else {
        //   this.sortBy = ['bankName', 'name'];
        //  this.sortDesc = [false, false];
      }
    },
    async onDelete() {
      const name = this.selectedBranch[0].name;
      await this.$axios.branches
        .delete(this.selectedBranch[0].branchId)
        .then((response) => {
          if (response.status == 200) {
            notifySuccess('', this.$t('Messages.BranchWasDeleted', [name]));
            this.showMessage(
              this.$t('Deleted'),
              `${this.$t('referenceBooks.branches.Name')}: ${name}`
            );
            this.selectedBranch = [];
          } else
            this.showMessage(
              this.$t('Deleted'),
              `${this.$t('referenceBooks.branches.Name')}: ${name}\n${this.$t(
                'Status'
              )}: ${response.status}`,
              'warn'
            );
          this.getData();
        })
        .catch((error) =>
          this.catchError(error, name, this.$t('errorsMessages.Delete'))
        );
    },
    catchError(error, name, errorHeader = '') {
      console.error(error);
      const status = error.response.status;
      const data = [error.response.data];

      const errorHeaderActual =
        errorHeader === '' ? this.$t('Error') : errorHeader;

      if (status === 400 || status === 401) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].errorType == 'HAS_RELATONS') {
            this.showMessage(
              `${errorHeaderActual}`,
              `${this.propertiesResponse[data[i].property]}<br>${this.$t(
                'referenceBooks.branches.Name'
              )}: ${name}`,
              'error'
            );
          } else if (data[i].errorType == 'NO_RIGHTS') {
            this.showMessage(
              `${errorHeaderActual}`,
              `${this.$t('errorsMessages.NoRights')}`,
              'error'
            );
          } else this.showMessage(errorHeaderActual, error, 'error');
        }
      } else {
        this.showMessage(errorHeaderActual, error, 'error');
      }
    },
    markRow(id) {
      this.changedBranchesId = [];
      this.changedBranchesId.push(id);
    },
    async onCreated(status, branchName, id) {
      this.getData();
      if (status == 200)
        this.showMessage(
          this.$t('referenceBooks.branches.created'),
          `${this.$t('referenceBooks.branches.Name')}: ${branchName}`
        );
      else
        this.showMessage(
          this.$t('referenceBooks.branches.created'),
          `${this.$t('referenceBooks.branches.Name')}: ${branchName}\n${this.$t(
            'Status'
          )}: ${status}`,
          'warn'
        );

      this.markRow(id);
    },
    async onSaved(status, branch) {
      this.getData();
      if (status == 200)
        this.showMessage(
          this.$t('referenceBooks.ChangedSaved'),
          `${this.$t('referenceBooks.branches.Name')}: ${branch.name}`
        );
      else
        this.showMessage(
          this.$t('referenceBooks.ChangedSaved'),
          `${this.$t('referenceBooks.branches.Name')}: ${
            branch.name
          }\n${this.$t('Status')}: ${status}`,
          'warn'
        );

      this.markRow(branch.branchId);
    },
    async onError(error, errorHeader = '') {
      this.catchError(error, null, errorHeader);
    },
    showMessage(title, text, type = '') {
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
    async onUnpinBranch() {
      const branchesId = this.selectedBranch.map((b) => b.branchId);

      await this.$axios.branches
        .unpin(branchesId)
        .then((response) => response.data)
        .then(() => {
          notifySuccess(
            '',
            this.$t('Messages.BranchWasUnpinnedFrom', [
              this.selectedBranch[0].name,
              this.selectedBranch[0].parentBranchName,
            ])
          );
          this.markRow(this.selectedBranch[0].branchId);
          this.getData();
        })
        .catch((error) => {
          console.error(error);

          notifyError('', this.$t('Error'));
        });
    },
  },
};
</script>
